module.exports = __webpack_public_path__ + "img/truck.c1eaa25f.svg";